import { Button } from "@/components/ui/button";

export function SkipNavigation() {
  return (
    <div className="sr-only focus-within:not-sr-only focus-within:absolute focus-within:top-4 focus-within:left-4 focus-within:z-[100]">
      <Button
        variant="gradient"
        size="sm"
        className="focus:not-sr-only"
        onClick={() => {
          const main = document.getElementById('main-content');
          if (main) {
            main.focus();
            main.scrollIntoView();
          }
        }}
      >
        Skip to main content
      </Button>
    </div>
  );
}